import moment from 'moment-timezone';

/**
 * Determina si un depósito está en el mes y año actual
 * @param {Object} deposito - Objeto del depósito
 * @returns {boolean}
 */
const isFromCurrentMonth = (deposito) => {
    const isCuentaActual = deposito.clave_rastreo !== undefined;
    const fecha = isCuentaActual ? deposito.spei_fechahora : deposito.date;
    if (!fecha) return false;

    const depositoDate = moment.utc(fecha);
    const now = moment();
    
    return depositoDate.month() === now.month() && depositoDate.year() === now.year();
};

/**
 * Obtiene el estado del depósito para Cuentitas
 * Lógica duplicada de Movements.jsx para consistencia en la utilidad
 */
const getDepositStatusForCuentita = (depositDate) => {
    const now = moment.utc();
    const endOfDayUTC = moment.utc(depositDate).endOf('day');
    return now.isSameOrBefore(endOfDayUTC) ? "programado" : "ejecutado";
};

/**
 * Obtiene la suma total de depósitos ejecutados en el mes actual
 * @param {string} accessToken - Token de acceso
 * @param {string} bpToken - Token BP (solo Cuenta Actual)
 * @param {string} accountType - 'Cuentita', 'Cuenta Actual' o 'Concentradora'
 * @returns {Promise<number>}
 */

export const fetchMonthlyDepositsSum = async (accessToken, bpToken, accountType) => {
    const apiUrl = process.env.REACT_APP_API_URL_DEV;
    let totalSum = 0;
    let page = 1;
    let hasMore = true;
    const limit = 100;

    try {
        while (hasMore) {
            let requestUrl;
            let headers = { 'authorization': accessToken };

            if (accountType === "Cuentita" || accountType === "Concentradora") {
                requestUrl = `${apiUrl}/api/v2/depositos?page=${page}&limit=${limit}`;
            } else if (accountType === "Cuenta Actual") {
                if (!bpToken) return 0;
                requestUrl = `${apiUrl}/depositos?page=${page}&limit=${limit}`;
                headers['bp-token'] = bpToken;
            } else {
                return 0;
            }

            const response = await fetch(requestUrl, { method: 'GET', headers });
            if (!response.ok) break;

            const resData = await response.json();
            const data = (accountType === "Cuentita" && resData.data) ? resData.data : (resData.Data || resData);
            
            if (!Array.isArray(data) || data.length === 0) break;

            let reachedPreviousMonth = false;

            for (const deposito of data) {
                const isCuentaActual = deposito.clave_rastreo !== undefined;
                const fecha = isCuentaActual ? deposito.spei_fechahora : deposito.date;
                const monto = isCuentaActual ? deposito.monto : deposito.amount;
                const estado = isCuentaActual ? deposito.spei_estatus : getDepositStatusForCuentita(fecha);

                const depositoDate = moment.utc(fecha);
                const now = moment();

                // Si el depósito es de un mes anterior, podemos dejar de buscar (asumiendo orden descendente por fecha)
                if (depositoDate.isBefore(now.startOf('month'))) {
                    reachedPreviousMonth = true;
                    continue; // Seguimos por si el orden no es perfecto, pero marcamos el fin
                }

                if (isFromCurrentMonth(deposito) && estado?.toLowerCase() === 'ejecutado') {
                    totalSum += parseFloat(monto) || 0;
                }
            }

            if (reachedPreviousMonth) {
                hasMore = false;
            } else {
                page++;
                // Seguridad para evitar bucles infinitos en caso de muchos datos
                if (page > 20) hasMore = false; 
            }
        }

        return totalSum;
    } catch (error) {
        console.error('Error fetching monthly deposits sum:', error);
        return 0;
    }
};
